import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import type { BlotterTradeEntry } from '@/store/blotter/api/types/BlotterTradeEntry.ts';
import type { ISODateTime } from '@/types/date.ts';

export type BlotterTodayTradesListQueryPayload = {
  showMyMainDeals: boolean;
  counterPartyBdrInitials: string[];
  fromDate?: ISODateTime;
  toDate?: ISODateTime;
};

export const historicalTradesList = (builder: WebapiEndpointBuilder) => {
  return builder.query<BlotterTradeEntry[], BlotterTodayTradesListQueryPayload>({
    // we need to disable caching for this query, it populates blotter grids at start and whenever filtering changes and new trades show up any time
    keepUnusedDataFor: 0,
    query: (body) => ({
      url: '/blotter/historicalTradesList',
      method: 'POST',
      body,
      headers: {
        Accept: '*/*', // will respond with a string of the json-serialized payload if we give "Accept: application/json" (true story)
      },
    }),
  });
};
